export var PurchaseStatus;
(function (PurchaseStatus) {
    // after creation of payment and before payment is done by user
    PurchaseStatus["PENDING"] = "pending";
    // while payment is done by user and is processing transaction
    PurchaseStatus["PROCESSING"] = "processing";
    // after payment was done by user and transaction has succeeded
    PurchaseStatus["SUCCEEDED"] = "succeeded";
    // after payment was done by user and transaction has failed
    PurchaseStatus["FAILED"] = "failed";
    // after payment was canceld by user
    PurchaseStatus["CANCELED"] = "canceled";
})(PurchaseStatus || (PurchaseStatus = {}));
//# sourceMappingURL=purchase-status.enum.js.map